

import { reactive, computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import ShareImagePart from '@/components/share/ShareImagePart.vue';
// import ShareUrlPart from '@/components/share/ShareUrlPart.vue';
import { websiteHost_ } from "@/config/config"
// import { copyToClipboardUsingTextarea } from '@/utils/utils'
// import Tips from '@/components/share/Tips.vue'
// import DialogShareTips from '@/components/share/DialogShareTips.vue'
// import QRCode from 'qrcodejs2'

export default {
    emits:["copyLink_","takeImage_",'copyCode_','close_'],
    name: 'ShareLink',
    props:["invCode"],
    components: {
        ShareImagePart,
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup(props,{emit}) {
        const textToCopy = ref<HTMLElement | null>(null);
        const local = computed(() => store.state.translation.locale)
        const store = useStore()
        const route = useRoute()
        const router = useRouter()
        const websiteHost = computed(() => websiteHost_)
        // const link = computed(()=> `${websiteHost_}/share_link?code=${store.state.share.shareInfo.inviteCode}` )
        const data = reactive({
            code: route.query.code || "******",
            p: ['url', 'image'].some((val) => route.query.p === val) ? route.query.p : "url"
        })

        const state = reactive({
            isCopiedCode: false
        })


        onMounted(async () => {
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang ?? 'cn' })
        })

        function back() {
            router.back()
        }

        function copyLink() {
            emit('copyLink_')
        }

        function takeImag() {
            emit('takeImage_')
        }

        function copyCode() {
            emit('copyCode_',textToCopy.value?.textContent)
        }

        function close() {
            emit('close_')
        }

        function toggleComponent(name: string) {
            if (name in state) {
                state[name] = !state[name]
            }
        }


        return {
            back,
            state,
            local,
            data,
            websiteHost,
            props,
            copyLink,
            toggleComponent,
            takeImag,
            copyCode,
            textToCopy,
            close
            // createQRCode
        }
    }
}
